import styled from "styled-components";
import {hexToRgba} from "../../../../../../themes/hex-to-rgba";
import {LiveCasinoGridItemBetIntervalDefaultBox} from "./live-casino-grid-item-bet-interval.default.box"

export const LiveCasinoGridItemBetIntervalSIBox = styled(LiveCasinoGridItemBetIntervalDefaultBox)`
    color: ${props => props.theme.colors.textDark};
    background: ${props => hexToRgba(props.theme.colors.backgroundLight, 0.98)};
    //border: 1px solid ${props => hexToRgba(props.theme.colors.brandSecondaryLight, 0.1)};
    box-shadow: 0px 3px 9px #00000080;
    letter-spacing: 0.48px;
`;
